// Public suffix per environment, mirroring the tld map in
// devops/terraform/_modules_tenants/_main/main.tf, including its default of "io" for anything
// not listed.
const EMBRACECLOUD_TLD: Record<string, string> = {
  production: 'nl',
  beta: 'nl',
  'stable-alpha': 'io',
  alpha: 'io'
}

export const embracecloudTld = (environment: string): string => EMBRACECLOUD_TLD[environment] ?? 'io'
